export default __webpack_public_path__ + "static/media/preferedvendor_4.a43116eb.png";